
import { faFilePdf, faPencilSquare, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Alert, Button, Container, Form, Modal, Stack, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DataHandler } from "../dataHandler";
import LogoHeader from "../logoHeader/logoHeader";
import { LieferscheinData } from "./lieferscheinData";
import Confirm, { ConfirmInfo } from "../confirmComponent/confirm";
import { HydroSpinner } from "../spinner/hydroSpinner";
import ModalAlert from "../sharedComponents/modalAlert";



function Liste() {

    const [lsData, setLsData] = useState<Array<LieferscheinData> | boolean | undefined>();
    const [error, setError] = useState<string | undefined>();
    const [confirmInfo, setConfirmInfo] = useState<ConfirmInfo>();
    const [showAll, setShowAll] = useState<boolean>(false);
    const navigate = useNavigate();



    const reload = () => {
        setLsData(undefined);
    }

    if (lsData === undefined) {
        setLsData(true);
        DataHandler.getLieferscheinList(showAll).then((data: Array<LieferscheinData>) => {
            setLsData(data);
        }).catch((error) => {
            setLsData(false);
            setError(error);
        });
        return (<HydroSpinner />);
    } else if (lsData === true)
        return (<HydroSpinner />);
    else if (lsData === false)
        return (<Container>
            <LogoHeader />
            <Container>
                <h3>Konnte Daten nicht laden.</h3>
                <Button onClick={reload} variant="primary">Neu laden</Button>
            </Container>
        </Container>)



    const getStateString = (state: number) => {
        if (1 === state)
            return "Neu";
        if (2 === state)
            return "Erledigt";
        return "Unbekannt";
    }

    const getTimeString = (timestamp: number) => {
        const date = new Date(timestamp);
        return <div><div>{date.toLocaleDateString()}</div><div>{date.toLocaleTimeString()}</div></div>
    }

    const setDone = (id: number) => {
        setConfirmInfo({
            text: 'Lieferschein wirklich abschließen?',
            onConfirmCallback: () => {

                DataHandler.setLieferscheinDone(id).then((data: Array<LieferscheinData>) => {
                    setLsData(data);
                });
                setConfirmInfo(undefined);
            },
            onAbortCallback: () => {
                setConfirmInfo(undefined);
            }
        })

    }

    const changeSwitch = () => {
        setLsData(undefined);
        setShowAll(!showAll);
    }


    const edit = (id: number) => {
        navigate("/ls/" + id);
    }

    const back = () => {
        navigate("/");
    }

    const createPdf = (id: number) => {
        DataHandler.createPdf(id);
    }

    let switchLabel = "Alle Lieferscheine anzeigen";
    if (showAll)
        switchLabel = "Aktive Lieferscheine anzeigen";

    return (
        <Container>
            <Confirm confirmInfo={confirmInfo} />
            <LogoHeader />
            <Form>
                <Form.Switch id="allSwitch" checked={showAll} onChange={changeSwitch} label={switchLabel}></Form.Switch>
            </Form>
            <Table striped bordered hover size="md">
                {error && <ModalAlert callback={()=>setError(undefined)} content={error} contentTitle="Fehler" variant="danger"></ModalAlert>}

                <thead>
                    <tr>
                        <th>Techniker</th>
                        <th>Status</th>
                        <th>Zeit</th>
                        <th>Kunde</th>
                        <th>Auftragsnummer</th>
                        <th>Schaden</th>
                        <th>Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {lsData.map(data => (
                        <tr className={data.state > 1 ? 'table-light' : data.json.kamerabericht === "on" || data.json.angebot === "on" ? 'table-warning' : data.json.imageCount === 0 ? 'table-primary' : ''}>
                            <td>{data.json.techniker}</td>
                            <td>{getStateString(data.state)}</td>
                            <td>{getTimeString(data.timestamp)}</td>
                            <td>
                                <div>{data.json.kundeName}</div>
                                <div>{data.json.kundeStrasse}</div>
                                <div>{data.json.kundeOrt}</div>
                            </td>
                            <td>{data.json.auftragsnummer}</td>
                            <td>
                                <div>{data.json.schadenName}</div>
                                <div>{data.json.schadenStrasse}</div>
                                <div>{data.json.schadenOrt}</div>
                            </td>
                            <td>
                                <Stack direction="horizontal" gap={1}>
                                    <Button onClick={() => { edit(data.id) }} variant="secondary">
                                        <FontAwesomeIcon icon={faPencilSquare} className={"left-icon"} />
                                        Lieferschein bearbeiten
                                    </Button>
                                    <Button onClick={() => { createPdf(data.id) }} variant="info">
                                        <FontAwesomeIcon icon={faFilePdf} className={"left-icon"} />
                                        Lieferschein laden
                                    </Button>
                                    {data.state < 2 ? <Button onClick={() => { setDone(data.id) }} variant="primary">
                                        <FontAwesomeIcon icon={faSquareCheck} className={"left-icon"} />
                                        Abschließen
                                    </Button> : null}

                                </Stack>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Stack direction="horizontal" gap={3}>
                <Button variant="primary" onClick={reload} >Neu laden</Button>
                <Button variant="secondary" onClick={back}>Zurück</Button>
            </Stack>
        </Container>

    )

}

export default Liste;


